import { cn } from '@/utils/tailwind';

import { FilterLayoutProps } from '../types';

import FilterSurface from './FilterSurface';

const FilterDesktop = ({
  search,
  before,
  after,
  children,
  tabsActive = false,
}: FilterLayoutProps) => (
  <div className="mr-6 hidden md:block" data-testid="filter-desktop">
    <div
      className={cn(
        'sticky z-2 h-auto w-[280px] p-[0_5px_5px]',
        tabsActive
          ? 'max-md:top-[calc(var(--header-height)+16px+47px+var(--height-mobile-top-nav))] max-md:max-h-[calc(100vh-var(--header-height)-16px-47px-var(--height-mobile-top-nav)-var(--height-desktop-top-nav)-var(--height-build-plans-header)-var(--height-sticky-menu-margin))] md:top-[calc(var(--header-height)+16px+47px)] md:max-h-[calc(100vh-var(--header-height)-16px-47px)]'
          : 'max-md:top-[calc(var(--header-height)+16px+var(--height-mobile-top-nav))] max-md:max-h-[calc(100vh-var(--header-height)-16px-var(--height-mobile-top-nav)-var(--height-desktop-top-nav)-var(--height-build-plans-header)-var(--height-sticky-menu-margin))] md:top-[calc(var(--header-height)+16px)] md:max-h-[calc(100vh-var(--header-height)-16px)]',
      )}
      data-testid="StickyArea"
    >
      <div className="hidden flex-col gap-4 md:flex">
        {before}
        {search && (
          <FilterSurface dataTestId="filter-desktop-search">
            {search}
          </FilterSurface>
        )}
        {children && (
          <FilterSurface
            dataTestId="filter-desktop-main"
            className="flex w-full flex-col gap-4"
          >
            {children}
          </FilterSurface>
        )}
        {after && (
          <FilterSurface dataTestId="filter-desktop-after">
            {after}
          </FilterSurface>
        )}
      </div>
    </div>
  </div>
);

export default FilterDesktop;
